import {
  ConfirmPhoneVerificationPayload,
  StartPhoneVerificationPayload,
} from '@api/api/user-schema';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import {
  confirmPhoneVerification,
  deleteUserPhone,
  getUserPhone,
  startPhoneVerification,
} from '@terminal/services/user-phone/user-phone-service';

export const QUERY_KEY_USER_PHONE = 'QUERY_KEY_USER_PHONE';

export const useUserPhone = (enabled = true) =>
  useQuery({
    queryKey: [QUERY_KEY_USER_PHONE],
    queryFn: getUserPhone,
    enabled,
  });

export const useStartPhoneVerification = () =>
  useMutation({
    mutationFn: (body: StartPhoneVerificationPayload) =>
      startPhoneVerification(body),
  });

export const useConfirmPhoneVerification = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (body: ConfirmPhoneVerificationPayload) =>
      confirmPhoneVerification(body),
    onSuccess: () =>
      queryClient.invalidateQueries({ queryKey: [QUERY_KEY_USER_PHONE] }),
  });
};

export const useDeleteUserPhone = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: deleteUserPhone,
    onSuccess: () =>
      queryClient.invalidateQueries({ queryKey: [QUERY_KEY_USER_PHONE] }),
  });
};
